// extracted by mini-css-extract-plugin
module.exports = {"csbqhi5":"csbqhi5","c8xlkjx":"c8xlkjx","tgkyo5n":"tgkyo5n"};